import React, { useState } from "react";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import GetUserInfoService from "../../../../../../service/GetUserInfoService";
import localeText from "../../../../../../locale";
import { useToastContext } from "../../../../../../contexts/ToastContext/ToastContext";

const getUserInfoService = new GetUserInfoService();

function getConfirmWord() {
  switch (localStorage.getItem("__extraconomy_locale")) {
    case "pt":
    case "es":
      return "CANCELAR";
    case "it":
      return "CANCELLARE";
    default:
      return "CANCEL";
  }
}

const DeleteAccountSection = () => {
  const { showSuccessToast, showErrorToast } = useToastContext();
  const [step, setStep] = useState(1);
  const [confirmWord, setConfirmWord] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  async function handleConfirmStep2() {
    setLoading(true);
    try {
      const res = await getUserInfoService.postCancelAccount(
        localStorage.getItem("__extraconomy_token"),
        localStorage.getItem("__extraconomy_username"),
        password,
      );
      if (res.messageCode !== 200001) {
        const msg = localeText("data")?.find((m) => m.code === res.messageCode)?.message;
        showErrorToast({ detail: msg || "error" });
      } else {
        showSuccessToast({ detail: "accountCanceledSuccessfully" });
        setTimeout(() => {
          localStorage.removeItem("__extraconomy_token");
          localStorage.removeItem("__extraconomy_username");
          window.location.replace("/login");
        }, 1500);
      }
    } catch (e) {
      if (e?.response?.status === 401 || e?.response?.status === 403) {
        localStorage.removeItem("__extraconomy_token");
        localStorage.removeItem("__extraconomy_username");
        window.location.replace("/login");
      } else {
        showErrorToast({ detail: "cancelAccountError" });
      }
    } finally {
      setLoading(false);
    }
  }

  function handleStep1Submit() {
    if (confirmWord === getConfirmWord()) {
      setStep(2);
      setConfirmWord("");
    } else {
      showErrorToast({ detail: "cancelAccountError" });
    }
  }

  return (
    <div>
      <h2 className="text-lg font-semibold m-0 mb-1" style={{ color: "var(--theme-text)" }}>
        {localeText("deleteAccount") || "Eliminar conta"}
      </h2>
      <p className="text-sm m-0 mb-3" style={{ color: "var(--theme-text-muted)" }}>
        {localeText("deleteAccountSubtitle") || "Gerencie o processo de cancelamento da conta."}
      </p>
      <hr className="mb-4" />
      <div
        className="border-round-md p-2 mb-3 flex align-items-center gap-2"
        style={{
          backgroundColor: "rgba(244, 67, 54, 0.1)",
        }}
      >
        <i className="pi pi-exclamation-circle text-lg" style={{ color: "#c62828" }} />
        <span style={{ color: "var(--theme-text)" }}>
          {localeText("deleteAccountWarning") || "Esta ação não pode ser desfeita."}
        </span>
      </div>
      <p className="text-sm m-0 mb-2" style={{ color: "var(--theme-text)" }}>
        {localeText("deleteAccountInfo") ||
          "Todos os seus dados, incluindo perfil e informações pessoais, serão removidos permanentemente."}
      </p>
      {step === 1 && (
        <div className="flex flex-column gap-3 mt-3">
          <label className="block text-sm" style={{ color: "var(--theme-text-muted)" }}>
            {localeText("writeCancelToConfirm") || "Digite CANCELAR para confirmar"} *
          </label>
          <InputText
            value={confirmWord}
            onChange={(e) => setConfirmWord(e.target.value)}
            className="w-full p-no-outline border-round-md"
            style={{ color: "var(--theme-text)" }}
          />
          <div className="flex gap-2" style={{ height: "40px" }}>
            <Button
              label={localeText("cancel")}
              className="p-button-outlined border-round-md flex-1 text-sm font-medium"
              style={{ borderColor: "var(--theme-border)", color: "var(--theme-text-muted)" }}
              onClick={() => setConfirmWord("")}
            />
            <Button
              label={localeText("confirm")}
              className="border-round-md flex-1 text-sm font-medium"
              style={{ backgroundColor: "#FB3748", color: "#fff", border: "none" }}
              onClick={handleStep1Submit}
              disabled={confirmWord.trim() !== getConfirmWord()}
            />
          </div>
        </div>
      )}
      {step === 2 && (
        <div className="flex flex-column gap-3 mt-3">
          <label className="block text-sm" style={{ color: "var(--theme-text-muted)" }}>
            {localeText("confirmYourPassword") || "Confirme sua senha"} *
          </label>
          <InputText
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            type="password"
            className="w-full p-no-outline border-round-md"
            style={{ color: "var(--theme-text)" }}
          />
          <div className="flex gap-2" style={{ height: "40px" }}>
            <Button
              label={localeText("cancel")}
              className="p-button-outlined border-round-md flex-1 text-sm font-medium"
              style={{ borderColor: "var(--theme-border)", color: "var(--theme-text-muted)" }}
              onClick={() => {
                setStep(1);
                setPassword("");
              }}
            />
            <Button
              label={localeText("deleteAccount") || "Eliminar conta"}
              loading={loading}
              className="p-button-danger border-round-md flex-1 text-sm font-medium"
              style={{ border: "none", backgroundColor: "#FB3748", color: "#fff" }}
              onClick={handleConfirmStep2}
              disabled={!password}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default DeleteAccountSection;
